import { Routes } from '@angular/router';
import { BaseLayoutComponent } from './layouts/in-app-layout/base-layout.component';
import { UnauthenticatedLayoutComponent } from './layouts/unauthenticated-layout/unauthenticated-layout.component';
import { SessionSigninComponent } from './modules/besharp-sessions/lib/components/session-signin/session-signin.component';
import { SessionSelectorComponent } from './modules/besharp-sessions/lib/components/session-selector/session-selector.component';
import { NewPasswordRequiredComponent } from './modules/besharp-sessions/lib/components/new-password-required/new-password-required.component';
import { OAuth2CallbackComponent } from './modules/besharp-sessions/lib/components/oauth2-callback/oauth2-callback.component';
import { PasswordResetComponent } from './modules/besharp-sessions/lib/components/password-reset/password-reset.component';
import { externalRoleGuard } from './core/auth/external-role-guard.service';
import { ChatPageComponent } from './pages/chat/chat-page.component';
import { UploadPageComponent } from './pages/upload/upload-page.component';
import { SimpleLayoutComponent } from './layouts/simple-layout/simple-layout.component';

export const routes: Routes = [
  {
    path: 'app',
    component: BaseLayoutComponent,
    canActivate: [externalRoleGuard],
    children: [
      { path: '', component: ChatPageComponent },
      { path: 'session/:id', component: ChatPageComponent },
    ],
  },
  {
    path: 'upload',
    component: SimpleLayoutComponent,
    // canActivate: [externalRoleGuard],
    children: [{ path: '', component: UploadPageComponent }],
  },
  {
    path: 'session',
    component: UnauthenticatedLayoutComponent,
    children: [
      { path: 'signin', component: SessionSigninComponent },
      { path: 'select', component: SessionSelectorComponent },
      { path: 'new-password-required', component: NewPasswordRequiredComponent },
      { path: 'reset-password', component: PasswordResetComponent },
      { path: 'oauth2/callback', component: OAuth2CallbackComponent },
      { path: '**', redirectTo: 'select' },
    ],
  },
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  { path: '**', redirectTo: 'app', pathMatch: 'full' },
];
